export default __webpack_public_path__ + "static/media/graph.e3f66d62.svg";